var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicalRedCross(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/redcross_medium") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile/tablet-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tablet---covid-19-Copy-9",
    transform: "translate(-354.000000, -514.000000)",
    fill: "#EF5959",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "survey",
    transform: "translate(134.000000, 270.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "redcross_medium",
    points: "280 262.734648 261.265352 262.734648 261.265352 244 238.734648 244 238.734648 262.734648 220 262.734648 220 285.265352 238.734648 285.265352 238.734648 304 261.265352 304 261.265352 285.265352 280 285.265352"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalRedCross);
export default __webpack_public_path__ + "static/media/medical_red_cross.e14f6f4a0304ed4d27074d3b23328244.svg";
export { ForwardRef as ReactComponent };